export default "__VITE_ASSET__DBIMaFmV__"